import ParkingLocationStepView from "./ParkingLocationStepView";

function ParkingLocationStep({ controller }) {
  /**
   * This method will handle the parking location change event
   * @param {int} value
   */
  function onParkingLocationChange(value) {
    controller.setVisitorData({
      ...controller.visitorData,
      parking_location_id: value,
      license_plate: value ? controller.visitorData.license_plate : "",
    });
  }

  /**
   * This method will handle the license plate change event
   * @param {event} e
   */
  function onLicensePlateChange(e) {
    controller.setVisitorData({
      ...controller.visitorData,
      license_plate: e.target.value,
    });
  }

  return (
    <ParkingLocationStepView
      controller={controller}
      onParkingLocationChange={onParkingLocationChange}
      onLicensePlateChange={onLicensePlateChange}
    />
  );
}

export default ParkingLocationStep;
